import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
	DiagnosisIntroPage,
	DiagnosisSheetPrintPage,
	// redirect page
	RedirectPage,
} from 'app/pages/diagnosis';

const DiagnosisPage = () => (
	<Switch>
		<Route
			exact
			path="/diagnosis"
			component={DiagnosisIntroPage}
		/>
		<Route
			path="/diagnosis/:carId/diagnosis-sheet"
			component={DiagnosisSheetPrintPage}
		/>
		<Route render={() => <RedirectPage type="404" />} />
	</Switch>
);

export default DiagnosisPage;
